<tt-grid *ngIf="!!grid" class="flex-1" [(ttOptions)]="grid" (ttCellDoubleClick)="onDoubleClick($event)"></tt-grid>
